import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { selectLanguage } from '@ff-os/pdp-shared-redux/slices/globalSlice';
import { urls } from '@ff-os/shared-utils/urls';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import classNames from 'classnames';
import { selectCommissionAssetId, selectCommissionName } from '../_redux-prefabs';
import styles from './DesignCredits.module.scss';

const _DesignCredits = ({ name, assetId, language }: Props) => {

    const { t } = useTranslation();

    if (!name) {
        return null;
    }

    const url = assetId && urls.loadPublicAsset(assetId, language);

    return (
        <div className={classNames(styles.container, 'idt-design-credits')}>
            <div className={styles.content}>
                <p className={styles.prefix}>{t('design_credits')}</p>

                <span className={styles.owner}>

                     {url && (
                         <img src={url} className={styles.image} alt='' />
                     )}

                    <p className={styles.name}>{name}</p>
                </span>
            </div>
        </div>
    );
};

type Props = OwnProps;

type OwnProps = {
    name: string | undefined;
    assetId: string | undefined;
    language: string;
};

const mapStateToProps = (state: GiftPdpState) => ({
    name: selectCommissionName(state),
    assetId: selectCommissionAssetId(state),
    language: selectLanguage(state)
});

export const DesignCredits = connect(
    mapStateToProps
)(_DesignCredits);